// @ts-nocheck
/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
export default class SceneFeature {
	/**
	 * Vytvoreni scene entity.
	 *
	 * @param  {Scene} scene Instance sceny.
	 * @param  {Number} itemId Jedinecne ID v ramci sceny.
	 */
	constructor(scene, itemId) {
		this._scene = scene;
		this._itemId = itemId;
		this._appended = false;
		this._sceneOwner = null;
		this._eventId = 0;

		this._style = {};
		this._attribute = {};
		this._events = [];
		this._operations = [];
		this._m3dData = {};
	}

	/**
	 * Destruktor.
	 */
	destroy(...args) {
		this._appended = false;
		this._sceneOwner = null;
		this._style = {};
		this._attribute = {};
		this._events = [];
		this._operations = [];

		this._onChange(this._scene.featureEvent("featureDestroy", true, true), args);
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "no-name",
			type: "no-type",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		return {
			appended: this._appended,
			sceneOwner: this._sceneOwner,
			operations: this._operations,
			style: this._style,
			attribute: this._attribute,
			events: this._events,
			m3dData: this._m3dData,
		};
	}

	/**
	 * Interni id pro scenu.
	 */
	get itemId() {
		return this._itemId;
	}

	/**
	 * Je entita pripnuta do sceny? Control a vrstva.
	 *
	 * @param  {Boolean} state
	 */
	set appended(state) {
		this._appended = state;
	}

	/**
	 * Interni pouziti pro scenu - u vrstev, markeru, kdo je jejich rodic.
	 *
	 * @param  {SceneFeature|Scene} owner Vlastnik
	 */
	set sceneOwner(owner) {
		this._sceneOwner = owner;
	}

	/**
	 * Je entita pripnuta do sceny?
	 */
	get appended() {
		return this._appended;
	}

	/**
	 * Vlastni - rodic entity.
	 */
	get sceneOwner() {
		return this._sceneOwner;
	}

	/**
	 * Proxy na nastaveni vlastnika - mapy api.
	 */
	setOwner(...args) {
		this._onChange(this._scene.featureEvent("featureSetOwner", true, true), args);
	}

	/**
	 * Ziskani DOM containeru dane entity.
	 *
	 * @param {Function} cb Callback funkce
	 * @param {Object} [scope = null] Vuci jakemu scopu volat funkci
	 * @param {Boolean} [save = false] Ulozit volani containeru i pri dalsim vytvoreni entity?
	 */
	getContainer(cb, scope, save) {
		if (save) {
			this._operations.push({
				cb: cb,
				scope: scope,
			});
		}

		this._onChange(this._scene.featureEvent("featureGetContainer", true, true), [cb, scope]);
	}

	/**
	 * Ziskani DOM containeru dane entity - synchronni verze.
	 *
	 * @return {Element|Object}
	 */
	getContainerSync() {
		return this._onChange(this._scene.featureEvent("featureGetContainerSync", true, true));
	}

	/**
	 * Nastav DOM style.
	 */
	setStyle(...args) {
		if (!args[0]) {
			return;
		}

		this._style[args[0]] = args[1];

		this._onChange(this._scene.featureEvent("featureSetStyle", true, true), args);
	}

	/**
	 * Nastaveni atributu DOM elementu.
	 */
	setAttribute(...args) {
		if (!args[0]) {
			return;
		}

		this._attribute[args[0]] = args[1];

		this._onChange(this._scene.featureEvent("featureSetAttribute", true, true), args);
	}

	/**
	 * Pridani posluchace pro DOM reprezentaci entity.
	 */
	addEventListener(...args) {
		const id = this._eventId;

		this._eventId++;

		this._events.push({
			id: id,
			name: args[0],
			cb: args[1],
			useCapture: args[2],
		});

		this._onChange(this._scene.featureEvent("featureAddEventListener", true, true), args);

		return id;
	}

	/**
	 * Odebrani posluchace pro DOM reprezentaci entity.
	 */
	removeEventListener(...args) {
		const len = this._events.length - 1;

		for (let index = len; index >= 0; index--) {
			const event = this._events[index];

			if (args[0] === event.name && (!args[1] || args[1] === event.cb) && (!args[2] || args[2] === event.useCapture)) {
				this._onChange(this._scene.featureEvent("featureRemoveEventListener", true, true), [event.name, event.cb, event.useCapture]);
				this._events.splice(index, 1);
			}
		}
	}

	/**
	 * Odebrani jednoho/vice posluchacu - ID ktere vraci addEventListener
	 */
	removeListeners(ids) {
		const all = typeof ids === "number" ? [ids] : ids;
		const len = this._events.length - 1;

		for (let index = len; index >= 0; index--) {
			const event = this._events[index];
			const ind = all.indexOf(event.id);

			if (ind !== -1) {
				this._onChange(this._scene.featureEvent("featureRemoveEventListener", true, true), [event.name, event.cb, event.useCapture]);
				this._events.splice(index, 1);
				all.splice(ind, 1);
			}

			if (!all.length) {
				break;
			}
		}
	}

	/**
	 * Nastaveni 3d dat.
	 *
	 * @param   {Object}  data Vlastani data
	 */
	updateM3dData(data = {}) {
		const oldM3dData = JSON.parse(JSON.stringify(this._m3dData));

		Object.assign(this._m3dData, data);
		this._onChange(this._scene.featureEvent("featureUpdateM3dData", true, true), [this._m3dData, oldM3dData]);
	}

	/**
	 * Nastala zmena entity, udalost preposleme do sceny.
	 * @param  {Object} eventItem Object vygenerovany pres scenu.
	 * @param  {Array} [opts = null] Volitelne pole argumentu
	 * @return {Object} Zalezi dle typy volane funkce
	 */
	_onChange(eventItem, opts) {
		return this._scene.featureChange(this, eventItem, opts);
	}
}
